import React from 'react';
import classes from './Header.css';
const header = () => (
        <h1 className = {classes.Header}>Reduxstagram</h1>
    );

export default header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js